// extracted by mini-css-extract-plugin
module.exports = {"heading":"supply-and-scheduling__AppointmentWaitTimes__heading","intro":"supply-and-scheduling__AppointmentWaitTimes__intro"};